import {useLocation, useNavigate} from "react-router-dom";
import {PageHeader} from "../../../components/PageHeader";
import React, {useEffect, useMemo, useState} from "react";
import {toKSTISOString, toKSTISOStringEnd, validationChecker} from "../../../components/commonmethod/CommonMethod";
import ApprovalComponent from "../../settings/approval/new/ApprovalComponent";
import {getEvaluationReportChildrenList, saveEvaluationReport} from "../../../api/evaluation/ReportService";
import {getCodes, selectCodesByParentId} from "../../../api/code/CodeService";
import {CodeSpecNum, ContentCategory, UserIdType, UserType} from "../../../constant/CodeSpecNum";
import {selectServiceCodeByParentId} from "../../../api/serviceCode/ServiceCodeService";
import {selectProgressStatus} from "../../../api/progressStatus/progressStatusService";
import Th_title from "../../../components/Th_title";
import useRequestData from "../../../hooks/useRequestData";
import DetailLinkedPagination from "../../../components/detailLayout/DetailLinkedPagination";
import {SelectComboBoxForCreate} from "../../../components/select/SelectComboBoxForCreate";
import {useDispatch, useSelector} from "react-redux";
import {getApprovalProcessSubmitPayload, clearApprovalProcessState} from "../../settings/approval/shared/approvalProcessStore";
import {
    EVALUATION_INCIDENT_LIST_HEADER,
    EVALUATION_INSPECTION_LIST_HEADER,
    EVALUATION_SERVICE_LIST_HEADER,
    EVALUATION_WORK_LIST_HEADER,
} from "../../../components/table/header/Headers";
import {apiLoading} from "../../../redux/slice/apiSlice";
import {onCreateClickListener, onCreateIdClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../components/selector/Selector";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import {inputOnChange} from "../../../components/commonmethod/simmsInputMethod";
import SimmsInput from "../../../components/input/SimmsInput";
import TableSizeSelector from "../../../components/select/TableSizeSelector";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import {
    ContentDetailTwoColLayout,
    DetailKvTable,
    DetailListPage,
    DetailOptionChips,
    DetailPanel,
    DetailSummaryButton,
    DetailSummaryListButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";
import "../../../components/detailLayout/detailLinkedList.css";
import {SettingsContentHeroActions} from "../../settings/shared/SettingsContentHeroActions";
import {renderReportCell, resolveReportColWidth} from "./evaluationReportTableShared";

function EvaluationReportSelectTable({headerColumns, data, pageInfo, checked, setChecked}) {
    const currentPage = pageInfo?.currentPage ?? 0;
    const pageSize = pageInfo?.size ?? data.length;
    const totalElements = pageInfo?.totalElements ?? 0;
    const allPageChecked = data.length > 0 && data.every((item) => checked.includes(item.id));

    const toggleAllOnPage = () => {
        const pageIds = data.map((item) => item.id);
        if (allPageChecked) {
            setChecked((prev) => prev.filter((id) => !pageIds.includes(id)));
        } else {
            setChecked((prev) => [...new Set([...prev, ...pageIds])]);
        }
    };

    const toggleRow = (id) => {
        setChecked((prev) => (
            prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
        ));
    };

    return (
        <div className="evaluation-report-select-table-wrap">
            <div className="evaluation-report-detail-table-wrap overflow-x-auto">
                <table className="w-full table-border-gary evaluation-report-data-table" style={{tableLayout: "fixed"}}>
                    <colgroup>
                        <col style={{width: "4%"}}/>
                        <col style={{width: "4%"}}/>
                        {headerColumns.map((col, index) => (
                            <col key={index} style={{width: resolveReportColWidth(col)}}/>
                        ))}
                    </colgroup>
                    <thead>
                    <tr>
                        <th className="common-table-th-main-color text-center">
                            <input
                                type="checkbox"
                                className="detail-table-checkbox"
                                checked={allPageChecked}
                                onChange={toggleAllOnPage}
                                aria-label="현재 페이지 전체 선택"
                            />
                        </th>
                        <th className="common-table-th-main-color text-center">No.</th>
                        {headerColumns.map((col, index) => (
                            <th key={index} className="common-table-th-main-color text-indent text-left">
                                {col.name}
                            </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {data.length > 0 ? data.map((item, rowIndex) => (
                        <tr key={item.id ?? rowIndex}>
                            <td
                                className="text-center pt-1.5 pb-1.5"
                                style={{border: "1px solid #e5e5e5"}}
                            >
                                <input
                                    type="checkbox"
                                    className="detail-table-checkbox"
                                    checked={checked.includes(item.id)}
                                    onChange={() => toggleRow(item.id)}
                                    aria-label={`${item.title ?? item.id} 선택`}
                                />
                            </td>
                            <td
                                className="text-center pt-1.5 pb-1.5"
                                style={{border: "1px solid #e5e5e5"}}
                            >
                                {totalElements - (currentPage * pageSize + rowIndex)}
                            </td>
                            {headerColumns.map((col, colIndex) => (
                                <td
                                    key={colIndex}
                                    className={`text-indent text-left pt-1.5 pb-1.5 align-top${Array.isArray(col.field) ? "" : " truncate"}`}
                                    style={{border: "1px solid #e5e5e5"}}
                                >
                                    {renderReportCell(item, col)}
                                </td>
                            ))}
                        </tr>
                    )) : (
                        <tr>
                            <td
                                colSpan={headerColumns.length + 2}
                                className="py-10 text-center text-[#888]"
                                style={{border: "1px solid #e5e5e5"}}
                            >
                                조회된 데이터가 없습니다.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function EvaluationReportCreate() {
    const location = useLocation();
    const type = location.pathname.split("/").pop();
    const today = new Date();
    const getMonthRange = (baseDate) => {
        const base = dayjs(baseDate);
        return {
            startDate: toKSTISOString(base.startOf("month").toDate()),
            endDate: toKSTISOStringEnd(base.endOf("month").toDate()),
        };
    };

    const initDate = getMonthRange(today);
    const [report, setReport] = useState({reportType: type, ...initDate});
    const navigate = useNavigate();
    const [code, setCode] = useState([]);
    const [assetField, setAssetField] = useState({});
    const [search, setSearch] = useState({type});
    const [progress, setProgress] = useState();
    const [checked, setChecked] = useState([]);
    const dispatch = useDispatch();
    const approvalProcessId = useSelector((state) => state.content.approvalProcess?.id);

    useEffect(() => {
        clearApprovalProcessState(dispatch);
        return () => clearApprovalProcessState(dispatch);
    }, [dispatch]);

    useEffect(() => {
        const fetchData = async (codeRequestFn, progressCategory) => {
            try {
                const [codeResponse, progressResponse] = await Promise.all([
                    codeRequestFn(),
                    selectProgressStatus(progressCategory),
                ]);

                const mappedCode = codeResponse.map(item => ({...item, checked: true}));
                const checkedIds = mappedCode.map(item => item.id);

                setCode(mappedCode);
                setReport((prev) => ({...prev, codeArray: checkedIds}));
                setSearch(prev => ({
                    ...prev,
                    code: checkedIds,
                    ...initDate,
                }));

                setProgress(progressResponse.data.map(item => ({
                    id: item.numericValue,
                    name: item.korValue,
                })));
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        switch (type) {
            case "inspection":
                fetchData(() => selectCodesByParentId(CodeSpecNum.InspectionRequestCode), ContentCategory.INSPECTION);
                break;
            case "incident":
                fetchData(() => selectCodesByParentId(CodeSpecNum.IncidentRequestCode), ContentCategory.INCIDENT);
                break;
            case "work":
                fetchData(() => selectCodesByParentId(CodeSpecNum.WorkRequestCode), ContentCategory.WORK);
                break;
            default:
                fetchData(() => selectServiceCodeByParentId(CodeSpecNum.ServiceRequestGroupCode), ContentCategory.SERVICE_REQUEST);
                break;
        }

        getCodes().then(response => setAssetField(response.data)).catch(error => console.error("Error fetching codes:", error));
    }, [type]);

    const title = {
        header: type === "inspection" ? "점검종합보고서" : type === "incident" ? "장애종합보고서" : type === "work" ? "작업종합보고서" : "요청종합보고서",
        fieldName: type === "inspection" ? "점검종류" : type === "incident" ? "장애종류" : type === "work" ? "작업종류" : "접수방법",
        indicator: type === "inspection" ? "평가관리/보고서 > 업무보고서 > 점검종합보고서" :
            type === "incident" ? "평가관리/보고서 > 업무보고서 > 장애종합보고서" :
                type === "work" ? "평가관리/보고서 > 업무보고서 > 작업종합보고서" :
                    "서비스요청 > 요청종합보고서",
    };

    const create = async () => {
        if (!validationChecker(report)) return;

        let ids;
        if (checked.length > 0) {
            ids = {ids: checked};
        } else {
            alert(`등록할 ${title.header}를 선택해주세요`);
            return;
        }

        dispatch(apiLoading(true));

        const finalData = {
            ...report,
            ...ids,
            codeArray: search.code.toString(),
            ...getApprovalProcessSubmitPayload(),
            startDate: search.startDate,
            endDate: search.endDate,
        };

        await saveEvaluationReport(finalData).then(response => {
            if (response.status === 200) {
                alert("등록되었습니다.");
                navigate(`/evaluation/report/${type}/${response.data.id}`, {
                    state: {test: location.state},
                });
            }
        }).finally(() => dispatch(apiLoading(false)));
    };

    const handleCreate = () => {
        if (window.confirm("등록 하시겠습니까?")) {
            create();
        }
    };

    const {data, pageInfo, dataHook} =
        useRequestData((conditions, pageable) => {
            const finalConditions = {
                ...search,
                type,
            };
            return getEvaluationReportChildrenList(finalConditions, pageable);
        }, initDate);

    useEffect(() => {
        if (search.startDate) {
            dataHook.handleSearch(search);
        }
    }, [search]);

    useEffect(() => {
        if (!data?.length) {
            setChecked([]);
            return;
        }
        setChecked(data.map((item) => item.id));
    }, [data]);

    const moveMonth = (offset) => {
        const base = search.startDate ? dayjs(search.startDate) : dayjs();
        const target = base.add(offset, "month");

        setSearch(prev => ({
            ...prev,
            startDate: toKSTISOString(target.startOf("month").toDate()),
            endDate: toKSTISOStringEnd(target.endOf("month").toDate()),
        }));
    };

    const handleCodeChipToggle = (option, checked) => {
        const updatedCode = code.map((item) =>
            item.id === option.id ? {...item, checked} : item
        );
        const checkedIds = updatedCode.filter(item => item.checked).map(item => item.id);

        setCode(updatedCode);
        setSearch(prev => ({
            ...prev,
            code: checkedIds,
        }));
    };

    const headerActions = (
        <SettingsContentHeroActions>
            <DetailSummaryListButton url={`/evaluation/report/${type}`}>취소</DetailSummaryListButton>
            <DetailSummaryButton onClick={handleCreate}>등록</DetailSummaryButton>
        </SettingsContentHeroActions>
    );

    const listHeader = type === "inspection" ? EVALUATION_INSPECTION_LIST_HEADER :
        type === "incident" ? EVALUATION_INCIDENT_LIST_HEADER :
            type === "work" ? EVALUATION_WORK_LIST_HEADER :
                EVALUATION_SERVICE_LIST_HEADER;

    const gridPageable = useMemo(() => ({
        pageNumber: pageInfo?.currentPage ?? 0,
        totalPages: Math.max(1, pageInfo?.totalPages ?? 1),
        totalElements: pageInfo?.totalElements ?? 0,
        pageSize: pageInfo?.size ?? 20,
        size: pageInfo?.size ?? 20,
    }), [pageInfo]);

    if (Object.keys(assetField).length === 0) {
        return null;
    }

    const selectionPanel = (
        <DetailPanel title={`${title.header} 선택`} className="evaluation-report-select-panel">
            <div className="evaluation-report-select-body">
                <DetailKvTable>
                <tbody>
                <tr>
                    <Th_title title={title.fieldName} colspan={3} className="fieldset-td" auth>
                        <DetailOptionChips
                            options={code}
                            onChange={handleCodeChipToggle}
                        />
                    </Th_title>
                </tr>
                {type !== "service" ? (
                    <tr>
                        <Th_title title="자산 그룹" colspan={1} className="fieldset-td" auth>
                            <Selector
                                onChange={(v) => onCreateClickListener(setSearch, "group", search.group, v)}
                                data={search.group}
                                entity="code"
                                parentKey={CodeSpecNum.AssetGroupCode}
                                recursive
                            />
                        </Th_title>
                        <Th_title title="업무 그룹" colspan={1} className="fieldset-td" auth>
                            <Selector
                                onChange={(v) => onCreateClickListener(setSearch, "task", search.task, v)}
                                data={search.task}
                                entity="code"
                                parentKey={CodeSpecNum.TaskGroupCode}
                                recursive
                            />
                        </Th_title>
                    </tr>
                ) : (
                    <tr>
                        <Th_title title="요청자" colspan={1} className="fieldset-td fieldset-td-input" auth>
                            <Selector
                                onChange={(value) => onCreateIdClickListener(
                                    setSearch, UserType.applier, UserIdType.applierId, search.applier, value
                                )}
                                data={search.applier}
                                uniqueKey={UserType.applier}
                                entity="userAccount"
                            >
                                <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                                <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                                <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                            </Selector>
                        </Th_title>
                        <Th_title title="처리담당자" colspan={1} className="fieldset-td fieldset-td-input" auth>
                            <Selector
                                onChange={(value) => onCreateIdClickListener(
                                    setSearch, UserType.handler, UserIdType.handlerId, search.handler, value
                                )}
                                data={search.handler}
                                uniqueKey={UserType.handler}
                                entity="userAccount"
                            >
                                <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                                <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                                <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                            </Selector>
                        </Th_title>
                    </tr>
                )}
                <tr>
                    <Th_title title="진행 단계" colspan={1} className="fieldset-td" auth>
                        <SelectComboBoxForCreate target="progress" options={progress} data={{data: search, fnc: setSearch}}/>
                    </Th_title>
                    <Th_title title="페이지 크기" colspan={1} className="fieldset-td" auth>
                        <TableSizeSelector handlePageSizeChange={dataHook.handlePageSizeChange} pageInfo={pageInfo}/>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="작성 기간" colspan={3} className="fieldset-td fieldset-td-input">
                        <div className="web-flex asset-detail-date-range items-center flex-wrap gap-2">
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setSearch, "startDate", v, false)}
                                data={search.startDate}
                                constraint={{lessThan: search.endDate && dayjs(search.endDate)}}
                                auth
                            />
                            <span className="asset-detail-date-range-sep">~</span>
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setSearch, "endDate", v, false)}
                                data={search.endDate}
                                constraint={{largerThan: search.startDate && dayjs(search.startDate)}}
                                auth
                            />
                            <DetailSummaryButton muted onClick={() => moveMonth(-1)}>지난달</DetailSummaryButton>
                            <DetailSummaryButton muted onClick={() => moveMonth(1)}>다음달</DetailSummaryButton>
                        </div>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>

                <EvaluationReportSelectTable
                    headerColumns={listHeader}
                    data={data ?? []}
                    pageInfo={pageInfo}
                    checked={checked}
                    setChecked={setChecked}
                />
                <DetailLinkedPagination
                    pageable={gridPageable}
                    onPageChange={dataHook.handleGridPageChange}
                />
            </div>
        </DetailPanel>
    );

    const reportInfoPanel = (
        <DetailPanel title="보고서 정보">
            <DetailKvTable>
                <tbody>
                <tr>
                    <Th_title title="보고서 제목" colspan={3} className="fieldset-td" required auth>
                        <SimmsInput onChange={(v) => inputOnChange(setReport, "name", v, true)} data={report.name}/>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    return (
        <div className="common-container container-height-full border-l-gray detail-list-layout asset-detail-list-layout flex min-h-0 flex-1 flex-col">
            <PageHeader
                header={title.header}
                indicator={`${title.indicator} > 등록`}
                headerActions={headerActions}
            />

            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailTwoColLayout
                        main={
                            <>
                                {reportInfoPanel}
                                {selectionPanel}
                            </>
                        }
                        aside={
                            <ApprovalComponent auth approvalProcessId={approvalProcessId}/>
                        }
                    />
                </div>
            </DetailListPage>
        </div>
    );
}

export {EvaluationReportCreate};
